import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]); // roda toda vez que a rota muda

  return null; 
  
}
